import { FC, ReactNode, useEffect, useState } from 'react';
import AliceCarousel, { DotsItem, Responsive } from 'react-alice-carousel';
import { Skeleton, useMediaQuery } from '@chakra-ui/react';

interface CarouselProps {
  responsiveData: Responsive;
  items: ReactNode[];
  className?: string;
  showDots?: boolean;
  enableAutoWidth?: boolean;
  dotsItems: (dotItem: DotsItem) => ReactNode;
}

const defaultItem: Responsive = { 0: { items: 1 } };

const Carousel: FC<CarouselProps> = ({
  responsiveData = defaultItem,
  items,
  dotsItems,
  className,
  showDots,
  enableAutoWidth,
  ...rest
}) => {
  const [responsiveCarousel, setResponsiveCarousel] = useState<Responsive>(defaultItem);
  const [hasLoaded, setHasLoaded] = useState<boolean>(true);
  const [mouseTracking] = useMediaQuery(['(max-width: 1099px)']);

  useEffect(() => {
    setResponsiveCarousel(responsiveData);
    setHasLoaded(true);
  }, [responsiveData]);

  return (
    <div className={className}>
      <Skeleton isLoaded={hasLoaded} color="white" fadeDuration={2} sx={{ borderRadius: '20px' }}>
        <AliceCarousel
          swipeDelta={60}
          infinite={false}
          disableButtonsControls
          mouseTracking={mouseTracking}
          responsive={responsiveCarousel ? responsiveCarousel : responsiveData}
          autoWidth={enableAutoWidth}
          items={items}
          disableDotsControls={!showDots}
          renderDotsItem={dotsItems}
          {...rest}
        />
      </Skeleton>
    </div>
  );
};

export default Carousel;
